import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import { useActiveProjectScope } from '@xver/hooks/useActiveProject';
import type { ListVolumesResponse } from '@xver/apis/v1/kufer/volumes/model';

export const VOLUMES_QUERY_KEY = 'apis.v1.kufer.volumes.list';

/** Statuses that are still converging, so the list is worth polling faster. */
const SETTLING_STATUSES = new Set(['pending', 'resizing', 'deleting']);

export function useVolumesQuery(containerId: string | undefined) {
    const { isResolved } = useActiveProjectScope();
    return useQuery<ListVolumesResponse>({
        queryKey: [VOLUMES_QUERY_KEY, containerId],
        queryFn: () => Endpoints.v1.Kufer.Volumes.listVolumes(containerId as string),
        enabled: !!containerId && isResolved,
        refetchInterval: (query) => {
            const volumes = query.state.data?.volumes ?? [];
            return volumes.some((volume) => SETTLING_STATUSES.has(volume.status)) ? 3000 : 15000;
        },
    });
}
